/* eslint-disable @typescript-eslint/no-use-before-define */
import { array, option } from 'fp-ts';
import { pipe } from 'fp-ts/function';
import { NestedTableNodeTree } from '../../types';
import { mergeRecords, mergeRecordsWithParent } from './mergeUtils';

/**
 * Convert a Nested Table Node Tree into a Collapsed State record for localStorage
 */

function convertNestedTableNode(
  value: NestedTableNodeTree,
  path: string,
  collapseByDefault = false,
): Record<string, boolean> {
  const nextPath = `${path}${path === '' ? '' : '.'}${value.id}`;
  return pipe(
    value.nestedData, // Grab the nestedData prop
    option.fromNullable, // Convert it to an Option
    option.map((v) => convertNestedTable(v, nextPath, collapseByDefault)), // Recurse through the nested data
    option.getOrElse(() => ({})), // Ensure we end up with a Record<string, boolean>
    mergeRecordsWithParent(nextPath, collapseByDefault), // Merge the child records above with the path for the current parent
  );
}

export function convertNestedTable(
  values: NestedTableNodeTree[],
  path = '',
  collapseByDefault = false,
): Record<string, boolean> {
  return pipe(
    values,
    array.map((v) => convertNestedTableNode(v, path, collapseByDefault)), // Create Record<string, boolean> for each table row
    array.reduce({} as Record<string, boolean>, mergeRecords), // Merge all of the Records into one
    mergeRecordsWithParent(path, collapseByDefault), // Finally add the current path's record
  );
}
